import React from 'react';

const InvoicesServiceIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 14H12V16H4V14ZM4 10H12V12H4V10ZM10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H9V7H14V18Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

const CertificateNegativeServiceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9V11H15V9H5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

const HistoryDetailedServiceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.714286 20H20V18.5714H1.42857V0H0V19.2857L0.714286 20ZM2.85714 16.4286V5L3.57143 4.28571H6.42857L7.14286 5V16.4286L6.42857 17.1429H3.57143L2.85714 16.4286ZM5.71429 15.7143V5.71429H4.28571V15.7143H5.71429ZM14.2857 2.14286V16.4286L15 17.1429H17.8571L18.5714 16.4286V2.14286L17.8571 1.42857H15L14.2857 2.14286ZM17.1429 2.85714V15.7143H15.7143V2.85714H17.1429ZM8.57143 16.4286V7.85714L9.28571 7.14286H12.1429L12.8571 7.85714V16.4286L12.1429 17.1429H9.28571L8.57143 16.4286ZM11.4286 15.7143V8.57143H10V15.7143H11.4286Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

const CentralRepairsServiceIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.62252 16.3964C1.62252 16.795 1.95313 17.1171 2.36234 17.1171H15.6329C16.0421 17.1171 16.3728 16.795 16.3728 16.3964V11.1486C16.3728 7.18018 13.0713 3.96396 8.99764 3.96396C4.92398 3.96396 1.62252 7.18018 1.62252 11.1486V16.3964ZM3.28712 11.1486C3.28712 8.07658 5.84414 5.58559 8.99764 5.58559C12.1511 5.58559 14.7082 8.07658 14.7082 11.1486V15.4955H6.50073V11.6441C6.50073 11.5203 6.3967 11.4189 6.26954 11.4189H5.25228C5.12512 11.4189 5.02109 11.5203 5.02109 11.6441V15.4955H3.28712V11.1486ZM2.17508 5.46171L3.09061 4.56982C3.16228 4.5 3.16228 4.38514 3.09061 4.31532L1.5208 2.78604C1.48603 2.7525 1.43909 2.73369 1.39017 2.73369C1.34125 2.73369 1.29431 2.7525 1.25954 2.78604L0.344013 3.67793C0.309592 3.71179 0.290283 3.75752 0.290283 3.80518C0.290283 3.85284 0.309592 3.89857 0.344013 3.93243L1.91383 5.46171C1.9855 5.53153 2.10109 5.53153 2.17508 5.46171ZM17.6559 3.67793L16.7404 2.78604C16.7056 2.7525 16.6586 2.73369 16.6097 2.73369C16.5608 2.73369 16.5139 2.7525 16.4791 2.78604L14.9093 4.31532C14.8749 4.34918 14.8556 4.39491 14.8556 4.44257C14.8556 4.49022 14.8749 4.53596 14.9093 4.56982L15.8248 5.46171C15.8965 5.53153 16.0144 5.53153 16.0861 5.46171L17.6559 3.93243C17.7276 3.86036 17.7276 3.74775 17.6559 3.67793ZM16.3959 18.5586H1.5994C1.19019 18.5586 0.859578 18.8806 0.859578 19.2793V19.8198C0.859578 19.9189 0.942808 20 1.04453 20H16.9507C17.0525 20 17.1357 19.9189 17.1357 19.8198V19.2793C17.1357 18.8806 16.8051 18.5586 16.3959 18.5586ZM8.35029 2.52252H9.64498C9.74671 2.52252 9.82994 2.44144 9.82994 2.34234V0.18018C9.82994 0.0810811 9.74671 0 9.64498 0H8.35029C8.24857 0 8.16534 0.0810811 8.16534 0.18018V2.34234C8.16534 2.44144 8.24857 2.52252 8.35029 2.52252Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

const DpaDpeServiceIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99994 13.6842C4.04649 13.6842 0.0344238 15.5684 0.0344238 17.8947V20H17.9655V17.8947C17.9655 15.5684 13.9534 13.6842 8.99994 13.6842ZM4.51718 7.36842C4.51718 8.48512 4.98947 9.55609 5.83015 10.3457C6.67083 11.1353 7.81104 11.5789 8.99994 11.5789C10.1888 11.5789 11.3291 11.1353 12.1697 10.3457C13.0104 9.55609 13.4827 8.48512 13.4827 7.36842M8.4396 0C8.10339 0 7.87925 0.221053 7.87925 0.526316V3.68421H6.75856V1.05263C6.75856 1.05263 4.23701 1.95789 4.23701 5C4.23701 5 3.39649 5.14737 3.39649 6.31579H14.6034C14.5474 5.14737 13.7629 5 13.7629 5C13.7629 1.95789 11.2413 1.05263 11.2413 1.05263V3.68421H10.1206V0.526316C10.1206 0.221053 9.9077 0 9.56029 0H8.4396Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

const TariffSocialServiceIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7553 1.17228C11.7581 0.47085 12.9213 0.120136 14.2349 0.120136C14.9569 0.120136 15.7491 0.305235 16.6115 0.694916C17.4739 1.07486 18.1558 1.52299 18.6572 2.03932C19.6901 3.2863 20.1213 4.73786 19.9709 6.394C19.8104 8.05015 19.2489 9.34584 18.2762 10.2616L10.665 17.6558C10.4745 17.8409 10.2338 17.9286 9.95304 17.9286C9.67226 17.9286 9.44162 17.8409 9.25109 17.6558C9.15847 17.567 9.08573 17.4606 9.03741 17.3433C8.9891 17.226 8.96625 17.1002 8.97031 16.9739C8.97031 16.7011 9.06056 16.4673 9.25109 16.2822L13.8539 11.8106C14.1046 11.5962 14.1046 11.3722 13.8539 11.1286C13.6032 10.8851 13.3725 10.8851 13.1519 11.1286L8.54914 15.6002C8.45633 15.691 8.34513 15.7622 8.22259 15.8091C8.10004 15.8561 7.9688 15.8778 7.83716 15.873C7.55638 15.873 7.32574 15.7853 7.13521 15.6002C7.0426 15.5115 6.96985 15.4051 6.92153 15.2877C6.87322 15.1704 6.85037 15.0446 6.85443 14.9183C6.85443 14.6455 6.94468 14.4117 7.13521 14.2266L11.738 9.75501C12.0087 9.51146 12.0087 9.2679 11.738 9.02435C11.5074 8.7808 11.2867 8.7808 11.036 9.02435L6.43326 13.5447C6.3394 13.6341 6.22802 13.7043 6.10573 13.7511C5.98343 13.798 5.8527 13.8205 5.72128 13.8174C5.4405 13.8174 5.19983 13.7298 4.98925 13.5447C4.78869 13.3596 4.68841 13.1355 4.68841 12.8627C4.68841 12.5899 4.79872 12.3464 5.01933 12.1321L9.63215 7.65073C9.88284 7.40718 9.88284 7.18311 9.63215 6.96878C9.38145 6.75446 9.14078 6.75446 8.92017 6.96878L4.26724 11.4599C4.04663 11.6547 3.81599 11.7619 3.56529 11.7619C3.28451 11.7619 3.04385 11.6644 2.86334 11.4599C2.67281 11.265 2.57254 11.0312 2.57254 10.7584C2.57254 10.4857 2.67281 10.2616 2.86334 10.0765C5.93187 7.07595 7.82713 5.26393 8.54914 4.59173L12.1191 8.02092C12.5101 8.38138 12.9614 8.56648 13.5129 8.56648C14.2149 8.56648 14.7664 8.2937 15.1776 7.74815C15.4583 7.34872 15.5586 6.91033 15.4784 6.42323C15.3982 5.93613 15.1876 5.52696 14.8466 5.18599L10.7553 1.17228ZM12.821 7.33898L8.54914 3.17913L1.44942 10.0765C0.607076 9.24842 0.125739 7.98196 0.0154323 6.25762C-0.0948741 4.54302 0.386463 3.05249 1.44942 1.80551C2.64273 0.655949 4.06669 0.0714264 5.72128 0.0714264C7.38591 0.0714264 8.79983 0.655949 9.95304 1.80551L14.2349 5.96536C14.4255 6.15045 14.5157 6.37452 14.5157 6.6473C14.5157 6.92007 14.4255 7.15388 14.2349 7.33898C14.0444 7.51434 13.8138 7.61176 13.5129 7.61176C13.2422 7.61176 13.0115 7.51434 12.821 7.33898Z"
        fill="#5FC3D3"
      />
    </svg>
  );
};

export {
  InvoicesServiceIcon,
  CertificateNegativeServiceIcon,
  HistoryDetailedServiceIcon,
  CentralRepairsServiceIcon,
  DpaDpeServiceIcon,
  TariffSocialServiceIcon,
};
